<template>
	<div class="iframe">
		<iframe :id="id" @load='finish' :params="params" :type="type" :requestUrl="requestUrl"  name="show-iframe" width="0" height="0" frameborder=0 :src="loadingUrl"></iframe>
		<!--<iframe src='' width="0" height="0" frameborder=0></iframe>-->
	</div>
</template>

<script>
	import { iframepost } from '../../assets/js/ajax';
	export default {

        data(){
            return{
                msg:'',
                iwindow:'',
                iframeIsLode:false,
                
            }
        },
        props:{
        	id:'',
        	loadingUrl:'',
        	requestUrl:'',
            type:'',
            params:'',
            callback:'',
            jsonStr:''
        },
        methods:{
            getList(requestUrl,type,params,callback,jsonStr){
                let _this=this;
                iframepost(_this.iwindow,requestUrl,_this.loadingUrl,_this,function(res){
                			//传回调函数给父组件
                        callback(res);
                },type,params,jsonStr)
            },
            finish(){
                this.iframeIsLode=true;
            }
        },
        mounted(){
            const oIframe = document.getElementById(this.id);
            console.log(oIframe);
            this.iwindow = oIframe.contentWindow;
        },
        watch:{//监听iframe是否加载完毕
            iframeIsLode:function (val) {
                if(val){
                	this.$emit('iframeIsLodeChange',val)
                }
            }
        }

    }
</script>

<style scoped="scoped">
	.iframe{
		width: 0;
		height: 0;
	}
</style>